<template>
  <div class="side-site-wrapper">
    <button @click.prevent="onBtnSideSiteClick()" class="btn-side-site-close">&nbsp;</button>
    <div class="side-site-inner">
      <div class="side-site-left">
        <div class="side-site-left__top">
          <span class="top__titleabove">CoolManagement System</span>
          <span class="top__name">CoolZone</span>
          <span class="top__subtitle">{{ pl ? 'Komora chłodziarki' : 'Fridge compartment' }}</span>
        </div>
        <div class="side-site-left__bottom">
          <div class="bottom__table">
            <h3>
              {{ pl ? 'Sprawdź jakie produkty przechowywać?' : 'Find out what products to store' }}
            </h3>
            <!-- <p>Poniżej znajdziesz wskazówki gdzie najlepiej przechowywać poszczególne grupy produktów:</p> -->
            <ul>
              <li
                @mouseover="onBoxHover(1)"
                @mouseleave="onBoxLeave()"
                :class="{ 'active': activeBox == 1 }"
              >
                <span class="table__function-name">
                  {{ pl ? 'Najwyższa półka:' : 'Top shelf:' }}
                </span>
                <br />
                <strong>
                  {{ pl ? 'jogurty, kefiry, nabiał, ciasta, desery' : 'yogurt, kephir, dairy, cakes, desserts' }}
                </strong>
              </li>
              <li
                @mouseover="onBoxHover(2)"
                @mouseleave="onBoxLeave()"
                :class="{ 'active': activeBox == 2 }"
              >
                <span class="table__function-name">
                  {{ pl ? 'Druga półka:' : 'Second shelf:' }}
                </span>
                <br />
                <strong>
                  {{ pl ? 'sery żółte, pleśniowe, dojrzewające, wędliny, szynki, kiełbasy' : 'hard cheese, blue cheese, ripening cheese, cold cuts, ham, sausages' }}
                </strong>
              </li>
              <li
                @mouseover="onBoxHover(3)"
                @mouseleave="onBoxLeave()"
                :class="{ 'active': activeBox == 3 }"
              >
                <span class="table__function-name">
                  {{ pl ? 'Trzecia półka:' : 'Third shelf:' }}
                </span>
                <br />
                <strong>
                  {{ pl ? 'dania gotowe: zupy, sałatki, obiady, przekąski' : 'convenience food: soups, salads, dinners, snacks ' }}
                </strong>
              </li>
              <li
                @mouseover="onBoxHover(4)"
                @mouseleave="onBoxLeave()"
                :class="{ 'active': activeBox == 4 }"
              >
                <span class="table__function-name">
                  {{ pl ? 'Górna szuflada:' : 'Top drawer:' }}
                </span>
                <br />
                <strong>
                  {{ pl ? 'warzywa i owoce głównie zielone' : 'fruits and vegetables, mainly green' }}
                </strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="side-site-right">
        <div class="side-site-right__image">
          <div
            class="image__box image__box--1"
            :class="{ 'active': activeBox == 1 }"
            @mouseover="onBoxHover(1)"
            @mouseleave="onBoxLeave()"
          ></div>
          <div
            class="image__box image__box--2"
            :class="{ 'active': activeBox == 2 }"
            @mouseover="onBoxHover(2)"
            @mouseleave="onBoxLeave()"
          ></div>
          <div
            class="image__box image__box--3"
            :class="{ 'active': activeBox == 3 }"
            @mouseover="onBoxHover(3)"
            @mouseleave="onBoxLeave()"
          ></div>
          <div
            class="image__box image__box--4"
            :class="{ 'active': activeBox == 4 }"
            @mouseover="onBoxHover(4)"
            @mouseleave="onBoxLeave()"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeBox: 1,
      timerActive: true,
      timeInterval: 3000
    };
  },
  methods: {
    onBoxHover: function(box_index) {
      this.activeBox = box_index;
      this.timerActive = false;
    },
    onBoxLeave: function() {
      this.timerActive = true;
    },
    onBtnSideSiteClick: function() {
      this.$emit("btnBackClicked");
    }
  },
  created() {
    let cmp = this;
    setInterval(function() {
      if (cmp.timerActive) {
        cmp.activeBox =
          cmp.activeBox >= 4
            ? (cmp.activeBox = 1)
            : (cmp.activeBox = cmp.activeBox + 1);
      }
    }, cmp.timeInterval);
  }
};
</script>

<style lang="scss" scoped>
.side-site-wrapper {
  position: fixed;
  top: 70px;
  left: 0px;
  width: 100%;
  height: calc(100vh - 70px);
  background: #fff;
  z-index: 2;

  .btn-side-site-close {
    font-family: "Lato";
    position: absolute;
    top: 20%;
    left: 0px;
    background: #e41429;
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    line-height: 19px;
    border: none;
    border-radius: 0 10px 10px 0;
    padding: 20px 30px 20px 30px;
    box-shadow: 0px 20px 30px #8a041a4d;
    transition: all 0.1s ease-in-out;

    &:before {
      content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS45OTYiIGhlaWdodD0iMTUuODQ3IiB2aWV3Qm94PSIwIDAgMTkuOTk2IDE1Ljg0NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmYmRiZDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xOC41OSwxMi45MTNIM2EuOTkuOTksMCwxLDEsMC0xLjk4MUgxOC41OWwtNS4zLTUuMjQ5YS45ODUuOTg1LDAsMCwxLS4zMTQtLjk4NiwxLDEsMCwwLDEsLjc0My0uNzI2LDEuMDA2LDEuMDA2LDAsMCwxLC45OTEuMzI1bDcsNi45MzNhLjk4NC45ODQsMCwwLDEsMCwxLjM4N2wtNyw2LjkzM2ExLjAwNywxLjAwNywwLDAsMS0xLjM1OC0uMDQyLjk4NC45ODQsMCwwLDEtLjA2Mi0xLjM0NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0zLjk0NSkiLz48L3N2Zz4=");
      position: absolute;
      top: 49%;
      left: 20px;
      transform: translateY(-50%) rotate(180deg);
    }

    &:hover {
      left: -10px;
    }
  }

  .side-site-inner {
    height: 100%;
    max-width: 1420px;
    width: calc(100vw / 12 * 9);
    margin-left: calc(100vw / 12 * 2);

    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 1600px) {
      width: calc(100vw / 12 * 10);
      margin-left: calc(100vw / 12 * 1);
    }

    .side-site-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 40%;

      @media only screen and (max-width: 1600px) {
        width: 50%;
      }

      .side-site-left__top {
        display: flex;
        flex-direction: column;

        .top__titleabove {
          font-size: 14px;
          font-weight: 300;
          margin-bottom: 10px;
          font-weight: 400;
        }

        .top__name {
          font-size: 44px;
          line-height: 42px;
          color: #e41429;
          font-weight: 700;
        }

        .top__subtitle {
          font-size: 34px;
          line-height: 42px;
          color: #e41429;
        }
      }

      .side-site-left__bottom {
        //

        .bottom__table {
          width: 100%;
          height: auto;
          border: 2px #5bc4f0 solid;
          background: #f7fdff;
          padding: 30px 20px;
          margin-top: 60px;
          border-radius: 20px;

          @media only screen and (max-width: 1600px) {
            margin-top: 20px;
          }

          h3 {
            color: #5bc4f0;
            font-size: 30px;
            line-height: 44px;
            font-weight: 500;
            margin-left: 20px;
          }

          p {
            margin-left: 20px;
            font-family: "Lato";
            font-size: 16px;
            line-height: 22px;
            color: #27241d;
            font-weight: 300;
            width: 80%;
          }

          ul {
            color: #27241d;
            padding-left: 0px;
            list-style: none;
            margin-bottom: 0px;

            li {
              font-size: 18px;
              line-height: 26px;
              padding: 10px 40px;
              margin-bottom: 5px;
              cursor: pointer;

              &.active {
                background: #5bc4f0;
                border-radius: 10px;
                color: #fff;

                .table__function-name {
                  &:before {
                    content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcuMzIyIDEyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTE2LjA4NywxNy4xNDFhMS4yMSwxLjIxLDAsMCwxLS4xMTYsMS42LDEuMjU5LDEuMjU5LDAsMCwxLTEuNjI2LjExNGwtNC45NzYtNC45YTEuMjExLDEuMjExLDAsMCwxLDAtMS43MTRsNC45NzYtNC45YTEuMjU5LDEuMjU5LDAsMCwxLDEuNjI2LjExNCwxLjIxLDEuMjEsMCwwLDEsLjExNiwxLjZMMTIuMDA3LDEzLjFsNC4xLDQuMDQxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMzM2IDE5LjEpIHJvdGF0ZSgxODApIi8+PC9zdmc+");
                  }
                }
              }

              .table__function-name {
                position: relative;

                &:before {
                  content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcuMzIyIDEyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojNWJjNGYwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTE2LjA4NywxNy4xNDFhMS4yMSwxLjIxLDAsMCwxLS4xMTYsMS42LDEuMjU5LDEuMjU5LDAsMCwxLTEuNjI2LjExNGwtNC45NzYtNC45YTEuMjExLDEuMjExLDAsMCwxLDAtMS43MTRsNC45NzYtNC45YTEuMjU5LDEuMjU5LDAsMCwxLDEuNjI2LjExNCwxLjIxLDEuMjEsMCwwLDEsLjExNiwxLjZMMTIuMDA3LDEzLjFsNC4xLDQuMDQxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMzM2IDE5LjEpIHJvdGF0ZSgxODApIi8+PC9zdmc+");
                  position: absolute;
                  left: -20px;
                  top: 0px;
                }
              }
            }
          }
        }
      }
    }

    .side-site-right {
      margin-left: 10%;
      width: 50%;
      display: flex;
      align-items: center;

      @media only screen and (max-width: 1600px) {
        width: 40%;
      }

      .side-site-right__image {
        position: relative;
        width: 100%;
        padding-top: 112.82%;
        background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_foto_full.jpg");
        background-size: cover;
        background-position: 50% 50%;
        border-radius: 20px;

        .image__box {
          position: absolute;
          opacity: 1;
          transition: all 0.3s ease-in-out;

          &.active {
            opacity: 0;
          }

          &.image__box--1 {
            top: 9.659%;
            left: 18.3333%;
            width: 57.5641%;
            height: 29.5454%;

            background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_box_1.png");
            background-size: cover;
            background-position: 50% 50%;
          }

          &.image__box--2 {
            top: 39.2045%;
            left: 18.3333%;
            width: 57.5641%;
            height: 16.3636%;

            background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_box_2.png");
            background-size: cover;
            background-position: 50% 50%;
          }

          &.image__box--3 {
            top: 55.5681%;
            left: 18.3333%;
            width: 57.5641%;
            height: 23.5227%;

            background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_box_3.png");
            background-size: cover;
            background-position: 50% 50%;
          }

          &.image__box--4 {
            top: 79.0909%;
            left: 18.3333%;
            width: 57.5641%;
            height: 14.659%;

            background: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_box_4.png");
            background-size: cover;
            background-position: 50% 50%;
          }
        }
      }
    }
  }
}
</style>